import React from 'react';
import { Paper, Typography, Button, Table, TableHead, TableContainer, TableBody, TableRow, TableCell, TableFooter, Chip } from '@mui/material';
import LinkOrdine from '../LinkOrdine';
import { MoreVert } from '@mui/icons-material';
import DefaultPaginator from '../../../paginator/DefaultPaginator';
import __t from '../../../../lib/traduzioni';
import useBSSLogger from '../../../../hooks/useBSSLogger';
import { useTheme } from '@emotion/react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const {logger} = useBSSLogger;

const StoricoOrdiniGrid = ({listaOrdini, stati, Paginator = DefaultPaginator, page, npagine, cambiaPagina, statoMenu, setStatoMenu, dialogDuplica, setDialogDuplica}) => {

    const theme = useTheme();

    return (
        <TableContainer component={Paper}>
            <Table size={"small"}>
                <TableHead>
                    <TableRow>                        
                        <TableCell sx={{fontWeight: "bold"}}>{__t("numordine")}</TableCell>
                        <TableCell sx={{fontWeight: "bold"}}>{__t("tracking")}</TableCell>
                        <TableCell sx={{fontWeight: "bold"}}>{__t("mittente")}</TableCell>
                        <TableCell sx={{fontWeight: "bold"}}>{__t("destinatario")}</TableCell>
                        <TableCell sx={{fontWeight: "bold"}}>{__t("statoordine")}</TableCell>
                        <TableCell sx={{fontWeight: "bold"}} align="right">{__t("totale")}</TableCell>
                        <TableCell sx={{fontWeight: "bold", width: "15px"}} align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {listaOrdini.map((ordine) => {

                        const stileStato = {
                            color: ordine.statoordine.coloretesto,
                            backgroundColor: ordine.statoordine.colorestato,
                            fontWeight: "bold"
                        }

                        return (
                            <TableRow key={ordine.id} sx={{
                                borderLeft: `10px solid ${stileStato.backgroundColor ?? theme.palette.primary.main}`,
                                "& ::selection": stileStato,
                                ...(statoMenu.open && statoMenu.ordine.id === ordine.id ? {
                                    borderBottom: `2px solid ${stileStato.backgroundColor ?? theme.palette.primary.main}`
                                } : {})
                            }}>
                                <TableCell>
                                    <LinkOrdine ordine={ordine} />                                    
                                </TableCell>
                                <TableCell>
                                    <LinkOrdine ordine={ordine} ordineLabel={__t("tracking")} />
                                </TableCell>
                                <TableCell>
                                    {ordine.indirizzomittente.contattare}
                                </TableCell>
                                <TableCell>
                                    {ordine.indirizzodestinatario.contattare}
                                </TableCell>
                                
                                <TableCell>
                                    <Chip sx={{
                                        width: "100%",
                                        ...stileStato
                                    }} label={ordine.statoordine.codicestato} />                                                                            
                                </TableCell>
                                
                                <TableCell align="right">
                                    <Typography variant={"h5"}>
                                        € {ordine.totaleivato.toFixed(2)}
                                    </Typography>
                                </TableCell>
                                <TableCell align="right">
                                    <Button  sx={{minWidth: 0, color: stileStato.backgroundColor}} onClick={e => setStatoMenu({anchorEl: e.currentTarget, open: true, ordine})}>
                                        <MoreVert />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )

                    })}
                </TableBody>
                {(npagine > 1) && (
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={6}>    
                                {Paginator({page, npagine, cambiaPagina})}  
                            </TableCell>
                        </TableRow>
                    </TableFooter>   
                )}           
            </Table>
        </TableContainer>
    )
}

export default StoricoOrdiniGrid;